let MAX_PAGE_NUMBER_SHOWN = 6;

export default MAX_PAGE_NUMBER_SHOWN;



// WEBPACK FOOTER //
// ./app/models/maxPageNumberShown.js